var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "truck-summary", style: _vm.containerHeight },
    [
      _c("truck-summary-modal", {
        attrs: {
          isVisible: _vm.isModalVisible,
          startTime: _vm.helper.get(_vm.routes, "0.startTime", null),
          routeDetails: _vm.routeDetails,
          routeIndex: _vm.routeIndex,
        },
        on: {
          onDialogClose: function ($event) {
            _vm.isModalVisible = false
          },
          onUpdateRouteDetails: _vm.updateRouteDetails,
          onUpdateModalVisibility: _vm.updateModalVisibility,
          onResetPlanId: function ($event) {
            _vm.$currTruckPlanId = null
          },
          onFailedOrders: _vm.handleFailedOrders,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isReorderModalVisible,
            title: _vm.$t("planning.reorderRoute"),
          },
          on: {
            "update:visible": function ($event) {
              _vm.isReorderModalVisible = $event
            },
            close: _vm.handleReorderModalClose,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 4 } },
            [
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 24, lg: 12 } }, [
                _vm._v(" " + _vm._s(_vm.$t("planning.indexRouteBefore")) + " "),
                _c("h3", [_vm._v(_vm._s(_vm.routeIndex + 1))]),
              ]),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 24, lg: 12 } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("planning.indexRouteAfter")) + " "
                  ),
                  _c("el-input", {
                    staticClass: "w-100",
                    attrs: { type: "number" },
                    on: { input: _vm.handleIndexAfterChange },
                    model: {
                      value: _vm.routeIndexAfter,
                      callback: function ($$v) {
                        _vm.routeIndexAfter = $$v
                      },
                      expression: "routeIndexAfter",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isReorderModalVisible = false
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("general.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmReorderRoute },
                },
                [_vm._v(" " + _vm._s(_vm.$t("general.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 8 } },
        [
          _c(
            "el-col",
            { attrs: { id: "sectionTitle" } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c("el-form-item", { staticClass: "w-100" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "mt-0 mb-0 text-center d-inline-block w-100",
                      },
                      [
                        !_vm.helper.isUndefined(_vm.truckInPlan) &&
                        _vm.truckInPlan.orderId &&
                        _vm.truckInPlan.orderId.length > 0
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-options": _vm.popperOptions,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("general.totalOrders")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.truckInPlan.orderId
                                              ? _vm.truckInPlan.orderId.length
                                              : 0
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.planId")
                                          ) + ": "
                                        ),
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm.truckInPlan.planId.join(", ")
                                        )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.shipRefs")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm
                                              .getShipRefsFromOrderId(
                                                _vm.truckInPlan.orderId
                                              )
                                              .join(", ")
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("font-awesome-icon", {
                                  staticClass: "d-none d-md-inline",
                                  attrs: { icon: "info-circle" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(
                          " " + _vm._s(_vm.currentTruck.plateNumber) + " "
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-block",
              attrs: { id: "sectionFunction" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  !_vm.isViewOnly
                    ? _c(
                        "el-form-item",
                        [
                          !_vm.$isMobile
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    placement: "top",
                                    content: _vm.isReorderingEnabled
                                      ? _vm.$t("planning.disableReordering")
                                      : _vm.$t("planning.enableReordering"),
                                  },
                                },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      disabled: _vm.isComponentDisabled(false),
                                    },
                                    model: {
                                      value: _vm.isReorderingEnabled,
                                      callback: function ($$v) {
                                        _vm.isReorderingEnabled = $$v
                                      },
                                      expression: "isReorderingEnabled",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isViewOnly
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "planning.tooltip.getUpdatedETA"
                                ),
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "disabled-btn-wrapper" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        disabled:
                                          _vm.isComponentDisabled(false) ||
                                          _vm.isCalculateETADisabled,
                                        size: "mini",
                                      },
                                      on: { click: _vm.updateETA },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: "clock",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { staticStyle: { width: "calc(100% - 100px)" } },
                    [
                      _c("el-input", {
                        staticClass: "w-100",
                        attrs: {
                          clearable: "",
                          size: "mini",
                          placeholder: _vm.$t(
                            "planning.placeholder.searchRouteByShipRef"
                          ),
                          disabled: _vm.isComponentDisabled(false),
                        },
                        on: { input: _vm.handleSearchShipRef },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-block",
              attrs: { id: "sectionUtilities" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            disabled: _vm.isComponentDisabled(true),
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.printPlanId"
                            ),
                          },
                          model: {
                            value: _vm.$currTruckPlanId,
                            callback: function ($$v) {
                              _vm.$currTruckPlanId = $$v
                            },
                            expression: "$currTruckPlanId",
                          },
                        },
                        _vm._l(_vm.truckPlanIds, function (planId) {
                          return _c("el-option", {
                            key: planId,
                            attrs: { label: planId, value: planId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.printPlanId"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "disabled-btn-wrapper" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.isComponentDisabled(false),
                                    type: "success",
                                    size: "mini",
                                  },
                                  on: { click: _vm.printPlanId },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "print", size: "lg" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  !_vm.isViewOnly
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t("planning.lockPlanId"),
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "disabled-btn-wrapper" },
                                [
                                  _c("el-switch", {
                                    staticClass: "ml-3",
                                    attrs: {
                                      disabled: _vm.isComponentDisabled(false),
                                      "active-text": _vm.$t(
                                        "planning.lockPlanId"
                                      ),
                                      "inactive-text": _vm.$t(
                                        "planning.unlockPlanId"
                                      ),
                                    },
                                    on: { change: _vm.toggleLockPlanId },
                                    model: {
                                      value: _vm.isLockPlanId,
                                      callback: function ($$v) {
                                        _vm.isLockPlanId = $$v
                                      },
                                      expression: "isLockPlanId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.isComponentDisabled(false) ||
                              _vm.isDriverSelectionDisabled,
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.searchDriver"
                            ),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleCurrentDriverChanges(true)
                            },
                          },
                          model: {
                            value: _vm.currentDriver,
                            callback: function ($$v) {
                              _vm.currentDriver = $$v
                            },
                            expression: "currentDriver",
                          },
                        },
                        _vm._l(_vm.driversList, function (driver) {
                          return _c(
                            "el-option",
                            {
                              key: driver.RecId,
                              attrs: {
                                disabled: _vm.blockedDrivers.includes(
                                  driver.RecId
                                ),
                                label:
                                  driver.UserName +
                                  " [" +
                                  driver.Carplate +
                                  "] ",
                                value: driver.RecId,
                              },
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(
                                  _vm._s(driver.UserName) +
                                    " [" +
                                    _vm._s(driver.Carplate) +
                                    "] "
                                ),
                              ]),
                              driver.UserName
                                ? _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          "" +
                                            (driver["MonitorType"] === "M"
                                              ? _vm.$t("planning.mobile")
                                              : _vm.$t("planning.noMonitor"))
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.isViewOnly
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t("planning.assignToDriver"),
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "disabled-btn-wrapper" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        padding: "5px 13px !important",
                                      },
                                      attrs: {
                                        type: "success",
                                        disabled:
                                          _vm.isComponentDisabled(false) ||
                                          _vm.isInvalidReadyToShip() ||
                                          _vm.isAssignDriverDisabled,
                                        size: "mini",
                                      },
                                      on: { click: _vm.assignToDriver },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: "people-carry",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isViewOnly
                    ? _c(
                        "el-form-item",
                        { staticClass: "d-none d-md-inline-block" },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm.isUnassignBtnDisabled
                                  ? [
                                      _vm.isPlanIdRoutesAllUnassigned
                                        ? [
                                            _vm._v(
                                              " · " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.unassignedRoutes"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                          ]
                                        : _vm._e(),
                                      _vm.isPlanIdRoutesSomeCompleted
                                        ? [
                                            _vm._v(
                                              " · " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.completedRoutes"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.unassignPlanId"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _c(
                              "span",
                              { staticClass: "disabled-btn-wrapper" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      padding: "5px 13px !important",
                                    },
                                    attrs: {
                                      type: "success",
                                      disabled:
                                        _vm.isComponentDisabled(false) ||
                                        _vm.isUnassignBtnDisabled,
                                      size: "mini",
                                    },
                                    on: { click: _vm.unassignPlanId },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: "hands",
                                        "aria-hidden": "true",
                                        size: "lg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isPlanIdBelongToDifferentUser(_vm.$currTruckPlanId)
            ? _c(
                "el-col",
                { staticStyle: { margin: "4px 22px" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "eye"], size: "lg" },
                  }),
                  _c("span", { staticClass: "ml-2" }, [
                    _c("i", [_vm._v(_vm._s(_vm.$t("planning.viewOnly")))]),
                    _c("b", { staticClass: "ml-1" }, [
                      _vm._v("- " + _vm._s(_vm.$t("general.createdBy")) + ":"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.getUsername()) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            [
              _c(
                "draggable",
                _vm._b(
                  {
                    staticClass: "list-group",
                    style: { height: _vm.listHeight },
                    attrs: {
                      disabled:
                        _vm.helper.isNotEmpty(_vm.searchText) ||
                        !_vm.isReorderingEnabled ||
                        _vm.isPlanIdBelongToDifferentUser(
                          _vm.$currTruckPlanId
                        ) ||
                        _vm.isDragRouteDisabled,
                      tag: "ul",
                    },
                    on: {
                      change: _vm.handleRouteChanges,
                      update: _vm.handleRouteUpdate,
                    },
                    model: {
                      value: _vm.routes,
                      callback: function ($$v) {
                        _vm.routes = $$v
                      },
                      expression: "routes",
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.routes, function (route, routeIndex) {
                      return _c(
                        "li",
                        {
                          key: "" + route.masterpointId,
                          staticClass: "list-group-item",
                          class: _vm.getRouteClass(route),
                          style: _vm.getRouteStyles(route),
                          on: {
                            click: function ($event) {
                              return _vm.onRouteClick(routeIndex)
                            },
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex" } },
                            [
                              _c(
                                "el-col",
                                { staticStyle: { width: "45px" } },
                                [
                                  _c("span", { staticClass: "point-index" }, [
                                    _vm._v(_vm._s(routeIndex + 1)),
                                  ]),
                                  route.waypointType === "P"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: {
                                          "margin-left": "13.5px",
                                        },
                                        attrs: {
                                          icon: "circle",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      })
                                    : _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: { "margin-left": "16px" },
                                        attrs: {
                                          icon: "map-marker",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _c("el-col", { staticClass: "route-container" }, [
                                _c(
                                  "span",
                                  { staticClass: "align-top" },
                                  [
                                    route.locked ||
                                    route.status.toUpperCase() === "COMPLETED"
                                      ? _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "lock" },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "top",
                                          "popper-options": _vm.popperOptions,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.gMap.waypointType"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.waypointType." +
                                                        route.waypointType
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.gMap.district"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    route.district === ""
                                                      ? "-"
                                                      : route.district
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.planId"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " + _vm._s(route.planId)
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.shipmentReference"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    route.shipmentReference
                                                      ? route.shipmentReference.join(
                                                          ", "
                                                        )
                                                      : ""
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("general.createdBy")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !_vm.helper.isUndefined(
                                                      route.user
                                                    )
                                                      ? route.user
                                                      : _vm.$userInformation
                                                          .user.name
                                                  )
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.remarks"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._l(
                                                  _vm.getOrdersField(
                                                    route.orderId,
                                                    "remarks"
                                                  ),
                                                  function (
                                                    item,
                                                    remarksIndex
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      { key: remarksIndex },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "break-word",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "• " +
                                                                _vm._s(item)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm.$userData.checkReadyToShip
                                              ? _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.readyToShip"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.isInvalidReadyToShip(
                                                          route
                                                        )
                                                          ? "NO"
                                                          : "YES"
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("font-awesome-icon", {
                                          staticClass: "d-none d-md-inline",
                                          class: {
                                            "invalid-ready-to-ship":
                                              _vm.isInvalidReadyToShip(route),
                                          },
                                          attrs: { icon: "info-circle" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "break-word d-inline-block display-address",
                                    class: { "ml-1": !_vm.$isMobile },
                                    style: {
                                      width:
                                        "calc(100% - " +
                                        (route.locked ||
                                        route.status.toUpperCase() ===
                                          "COMPLETED"
                                          ? 65
                                          : 80) +
                                        "px)",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-inline-block" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                _vm.getWaypointFromId(
                                                  route.masterpointId,
                                                  "startTime"
                                                ),
                                                _vm.$timezone,
                                                "YY-MM-DD"
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.getStartAndEndTime(
                                                route.waypointId
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    route.shipmentReference.length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-inline-block ml-1",
                                          },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                "- (" +
                                                  _vm._s(
                                                    route.shipmentReference
                                                      .length
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.shipRefs"
                                                    )
                                                  ) +
                                                  ")"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    route.shipmentReference.length === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-inline-block ml-1",
                                          },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                "- (" +
                                                  _vm._s(
                                                    route.shipmentReference[0]
                                                  ) +
                                                  ")"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm.$selectedTruck &&
                                !_vm.isRouteBelongToDifferentUser(route)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "float-right cursor-pointer d-none",
                                        class: {
                                          "d-md-inline-block":
                                            !_vm.isRouteBelongToDifferentUser(
                                              route
                                            ) &&
                                            !(
                                              _vm.isManualAssignLoading ||
                                              _vm.isAutoAssignLoading
                                            ),
                                        },
                                        staticStyle: { "margin-left": "8px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openRouteDetails(
                                              routeIndex,
                                              route
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "edit",
                                            "aria-hidden": "true",
                                            size: "lg",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.$selectedTruck &&
                                !_vm.isRouteBelongToDifferentUser(route)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "float-right cursor-pointer d-none",
                                        class: {
                                          "d-md-inline-block":
                                            !_vm.isRouteBelongToDifferentUser(
                                              route
                                            ) &&
                                            !(
                                              _vm.isManualAssignLoading ||
                                              _vm.isAutoAssignLoading
                                            ),
                                        },
                                        staticStyle: { "margin-left": "8px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openReorderRoute(
                                              routeIndex,
                                              route
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "random",
                                            "aria-hidden": "true",
                                            size: "lg",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "position-relative",
                                    staticStyle: { top: "-8px" },
                                  },
                                  [
                                    _vm.hasAssemblyMinutes
                                      ? [
                                          _vm._l(
                                            _vm.getOrdersField(
                                              route.orderId,
                                              "remarks"
                                            ),
                                            function (item, remarksIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key: remarksIndex,
                                                  staticClass: "break-word",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "break-word",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "• " + _vm._s(item)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "break-word" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getOrderField(
                                                    _vm.getOrderId(route),
                                                    "serviceName"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _c("div", { staticClass: "break-word" }, [
                                      _vm._v(_vm._s(route.displayAddress)),
                                    ]),
                                    _c(
                                      "div",
                                      { class: _vm.isRouteLate(route) },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("planning.tooltip.eta")
                                            ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                route.estimateTime,
                                                _vm.$timezone
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.actualFinishDate"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getRouteActualFinishTime(route)
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    route.updated
                                      ? _c(
                                          "div",
                                          { staticClass: "route-update" },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1",
                                              attrs: { icon: "bullhorn" },
                                            }),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.hasUpdatedFields"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }